import { ZAttrMeta } from "../attribute";
import { ZSpecification } from "./ZSpecification";

export const makeAttrMetaMap = (
  scheme: ZSpecification,
): Record<string, ZAttrMeta> => {
  const dict: Record<string, ZAttrMeta> = {};
  scheme.definition?.attributes.forEach((attr) => {
    dict[attr.name] = attr;
  });
  return dict;
};
